import { render, staticRenderFns } from "./Bowser.vue?vue&type=template&id=6279a4f9&"
import script from "./Bowser.vue?vue&type=script&lang=ts&"
export * from "./Bowser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports